module.exports = "<user-list>Loading...</user-list>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/users/users.component.html
// module id = 2174
// module chunks = 0